/* bmcf-cart.js, builder F (whole-store Josh pass, 2026-09-28).
   Loads on store pages only (snippets/bmc-store.liquid is never rendered on bmc-landing* pages).
   Does nothing while the cart holds a landing product or one of its add-ons (state.frozen): that is the A/B buyers'
   path and stays exactly as it is.
   1) Monster cart drawer extras: item count in the header, subtotal and real savings, delivery facts, View cart link,
      help line, best-seller links when empty. Monster's own nodes are never moved or rewritten; everything added
      carries data-bmcf and is re-inserted when Monster re-renders.
   2) Desktop only: hover preview of the cart under the header cart icon.
   3) /cart page: discount code box, Save for later, delivery dates.
   Cart state comes from snippets/bmcf-cart-state.liquid (inline at page load, then ?section_id=bmcf-cart-state
   ONLY when the drawer's items or total change). No polling, no /cart.js loop. */
(function () {
  var W = window, D = document, R = D.documentElement;
  var F = W.bmcF = W.bmcF || {};
  if (F.init) return;
  F.init = true;

  var FROZEN = ['compose-game-ready-music-in-60-days', 'challenge-start', 'blueprint-start', 'challenge-offer', '60-day-offer',
    'compose-music-like-toby-fox-challenge', 'compose-music-inspired-by-ocarina-of-time', 'scoring-the-game',
    'looping-offer', 'book-offer', 'digital-bonuses'];
  var MAIL = 'support@bestmusiccoach.com';
  var BEST = '/collections/online-courses?sort_by=best-selling', BEST_BOOKS = '/collections/music-books?sort_by=best-selling';
  var LOCK = '<svg aria-hidden="true" focusable="false" viewBox="0 0 16 21" width="12" height="16"><path fill="currentColor" d="M8 .5c-2.2 0-4 1.9-4 4.3V7.5H1a.5.5 0 0 0-.5.5v12c0 .3.2.5.5.5h14c.3 0 .5-.2.5-.5V8a.5.5 0 0 0-.5-.5h-3V4.8C12 2.4 10.2.5 8 .5zm-2.5 7V4.8c0-1.6 1.1-2.8 2.5-2.8s2.5 1.2 2.5 2.8v2.7z"/></svg>';
  var TRUCK = '<svg aria-hidden="true" focusable="false" viewBox="0 0 20 20" width="16" height="16"><path fill="currentColor" d="M0 3.75c0-.28.22-.5.5-.5h10.15c.27 0 .5.22.5.5v9.91l-.6 1H7.22v-1h2.93V4.25H1v9.41h1.68v1H.5a.5.5 0 0 1-.5-.5zm19 4.33-7.85-1.97V5.07l8.47 2.14c.22.05.38.25.38.48v6.47a.5.5 0 0 1-.5.5h-2.2v-1H19zm-7.85 5.58h2.2v1h-2.8zM5.15 11.62a2.56 2.56 0 1 1 0 5.13 2.56 2.56 0 0 1 0-5.13m0 1a1.56 1.56 0 1 0 0 3.12 1.56 1.56 0 0 0 0-3.12m9.8-1a2.56 2.56 0 1 1 0 5.13 2.56 2.56 0 0 1 0-5.13m0 1a1.56 1.56 0 1 0 0 3.12 1.56 1.56 0 0 0 0-3.12"/></svg>';
  var CHECK = '<svg aria-hidden="true" focusable="false" viewBox="0 0 12 9" width="12" height="10"><path fill="currentColor" d="M11.35.64a.5.5 0 0 1 0 .71L4.59 8.24a.5.5 0 0 1-.72 0L.64 4.85a.5.5 0 1 1 .72-.7l2.87 3.02L10.64.65a.5.5 0 0 1 .71-.01z"/></svg>';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
  function parseState(txt) { try { return JSON.parse(txt); } catch (e) { return null; } }
  function isFrozen(s) {
    if (!s) return true;
    if (s.frozen) return true;
    return (s.items || []).some(function (i) { return FROZEN.indexOf(i.h) !== -1; });
  }
  var el0 = D.getElementById('bmcF-state');
  var pt0 = D.getElementById('bmcW3A-pt');
  F.pt = pt0 ? pt0.innerHTML.trim() : '';
  F.state = el0 ? parseState(el0.textContent) : null;
  F.at = Date.now();
  function live() { return !isFrozen(F.state); }
  function setFlags() {
    R.classList.toggle('bmcF-on', live());
    R.classList.toggle('bmcF-ships', !!(F.state && F.state.ships));
    R.classList.toggle('bmcW3A-noap', live() && !F.state.ap);
  }
  setFlags();

  /* ---------- delivery dates (shipping policy, f9za W5SHIP 2026-10-05: printed in the US in 3 to 5 business days, then
     5 to 7 business days by USPS Media Mail in the continental US, so 8 to 12 business days from today; sources in
     swarm-w5/shipping/transit.json) ---------- */
  function addBiz(d, n) { d = new Date(d.getTime()); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
  function day(d) { try { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); } catch (e) { return d.toDateString().slice(4, 10); } }
  F.eta = function () { var now = new Date(); return day(addBiz(now, 8)) + ' to ' + day(addBiz(now, 12)); };
  function fillEta() {
    [].forEach.call(D.querySelectorAll('[data-bmcf-eta]'), function (el) { var t = F.eta(); if (el.textContent !== t) el.textContent = t; });
  }

  /* ---------- state refresh ---------- */
  function stateUrl() {
    var u = '/cart?section_id=bmcf-cart-state';
    var th = W.Shopify && W.Shopify.theme;
    if (th && th.role && th.role !== 'main' && th.id) u += '&preview_theme_id=' + th.id;
    return u;
  }
  var busy = false, again = false, waiters = [];
  function refresh(cb) {
    if (cb) waiters.push(cb);
    if (busy) { again = true; return; }
    busy = true;
    fetch(stateUrl(), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var m = html && html.match(/<script type="application\/json" id="bmcF-state">([\s\S]*?)<\/script>/);
      var s = m && parseState(m[1]);
      if (s) { F.state = s; F.at = Date.now(); var pm = html.match(/<template id="bmcW3A-pt">([\s\S]*?)<\/template>/); F.pt = pm ? pm[1].trim() : ''; }
    }).catch(function () {}).then(function () {
      busy = false; setFlags(); paintDrawer(); paintMini();
      var list = waiters; waiters = [];
      list.forEach(function (f) { try { f(); } catch (e) {} });
      if (again) { again = false; refresh(); }
    });
  }

  /* ---------- copy ---------- */
  function shipLines(s) {
    var out = [];
    if (s.ships) {
      if (!s.zone) out.push(['is-warn', TRUCK + '<span>Books ship only to the US, UK and Canada.</span>']);
      else if (!s.books) out.push(['is-ok', TRUCK + '<span><strong>Free delivery</strong> to the US, UK and Canada.</span>']);
      else if (s.fs === 'ok') out.push(['is-ok', TRUCK + '<span><strong>You get free shipping.</strong> Orders of $50 and up ship free to the US, UK and Canada.</span>']);
      else if (s.fs === 'need') out.push(['', TRUCK + '<span>Books ship to the US, UK and Canada, ' + esc(s.rate) + ' flat. <strong class="bmcW6A-fs">Add ' + esc(s.need) + ' more for free shipping.</strong></span>']);
      else if (s.fs === 'usd') out.push(['', TRUCK + '<span>Books ship to the US, UK and Canada, ' + esc(s.rate) + ' flat. Orders of US$50 and up ship free.</span>']);
      else out.push(['', TRUCK + '<span>Books ship to the US, UK and Canada, ' + esc(s.rate) + ' flat.</span>']);
      if (s.zone && s.country === 'US') out.push(['is-eta', '<span>Estimated delivery in the continental US: <span data-bmcf-eta>' + esc(F.eta()) + '</span>.</span>']);
      /* f9za (W5SHIP): UK and Canada times from Bookvault, Royal Mail and Purolator, read 2026-10-01 (swarm-w5/shipping/transit.json) */
      else if (s.zone && s.country === 'GB') out.push(['is-eta', '<span>Printed to order in the UK (about 3 business days), then usually 2 to 5 business days by Royal Mail or The Delivery Group.</span>']);
      else if (s.zone && s.country === 'CA') out.push(['is-eta', '<span>Printed to order in Canada (3 to 5 business days), then usually 1 to 5 business days by Purolator Ground.</span>']);
    }
    if (s.digital) out.push(['is-ok', CHECK + (s.ships ? '<span>Courses: instant access by email.</span>' : '<span><strong>Nothing ships.</strong> Instant access by email.</span>')]);
    return out.map(function (l) { return '<p class="' + l[0] + '">' + l[1] + '</p>'; }).join('');
  }

  /* ---------- W3A (swarm wave 3): refunds lines, Shop Pay installments banner ---------- */
  function polLines(s) {
    var out = [];
    if (s.starter) out.push('Starter courses: 30-day money-back guarantee. Ask within 30 days of purchase for a full refund.');
    if (s.main) out.push('All sales are final on ' + esc(s.main) + '.');
    if (s.b1) out.push('Book 1: follow the steps in the book and still cannot read music or write basic melody and chord songs? Email support@bestmusiccoach.com with your order number and you get your money back.');
    if (s.ships) out.push('Books: ask for a return within 30 days of delivery. The book must be unused and in its original condition.');
    return out;
  }
  function polDrawer(s) {
    var l = polLines(s);
    if (!l.length) return '';
    return '<details class="bmcW3A-pol"><summary>' + (s.b1 ? 'Book 1 money-back guarantee and 30-day returns' : 'Refunds and returns') + '</summary>' + l.map(function (x) { return '<p>' + x + '</p>'; }).join('') +
      '<p><button type="button" class="bmcW4A-polbtn" data-bmcw4a-pol="/policies/refund-policy">Read the full refund policy now</button></p></details>';
  }
  function ptLoad() {
    if (F.ptLoad || !W.customElements || W.customElements.get('shopify-payment-terms')) return;
    var fa = W.Shopify && W.Shopify.featureAssets && W.Shopify.featureAssets['shop-js'];
    var src = fa && fa['payment-terms'] && fa['payment-terms'][0];
    if (!src) return;
    F.ptLoad = true;
    var sc = D.createElement('script'); sc.type = 'module'; sc.async = true;
    sc.src = /^https?:/.test(src) ? src : 'https://cdn.shopify.com/shopifycloud/shop-js/' + src;
    D.head.appendChild(sc);
  }
  /* ---------- W6A (wave 6): savings by discount (with the sale's end) under "You save" ---------- */
  function savesHtml(s, cls) {
    var l = s.saves || [];
    if (!l.length) return '';
    return l.map(function (x) { return '<p class="' + cls + '">' + esc(x.t) + (x.sale ? ' <span class="bmcW6A-ends">(sale ends Oct 31, 11:59 pm ET)</span>' : '') + ': <b>' + esc(x.a) + '</b></p>'; }).join('');
  }
  function itemsWord(n) { return n + (n === 1 ? ' item' : ' items'); }

  /* ---------- 1) Monster drawer ---------- */
  // Links we add inside Monster's drawer are bound directly: the event stops here (before Monster's own drawer
  // handlers), and if something upstream already cancelled it we follow the link ourselves.
  function follow(e) {
    e.stopPropagation();
    if (e.defaultPrevented && !(e.metaKey || e.ctrlKey || e.shiftKey)) W.location.href = this.href;
  }
  function mine(id, html, place) {
    var n = D.getElementById(id);
    if (!n) { n = D.createElement('div'); n.id = id; n.setAttribute('data-bmcf', ''); }
    if (n.getAttribute('data-h') !== html) {
      n.innerHTML = html; n.setAttribute('data-h', html);
      [].forEach.call(n.querySelectorAll('a[href]'), function (a) { a.addEventListener('click', follow); });
    }
    place(n);
    return n;
  }
  function drop(id) { var n = D.getElementById(id); if (n && n.parentNode) n.parentNode.removeChild(n); }
  function after(ref, n) { if (ref && ref.parentNode && ref.nextSibling !== n) ref.parentNode.insertBefore(n, ref.nextSibling); }
  function before(ref, n) { if (ref && ref.parentNode && ref.previousSibling !== n) ref.parentNode.insertBefore(n, ref); }
  function smallestText(root, re) {
    var hit = null;
    [].forEach.call(root.querySelectorAll('a, button, span, p, div'), function (e) {
      if (e.closest('[data-bmcf]')) return;
      var t = (e.textContent || '').trim();
      if (re.test(t) && (!hit || hit.contains(e))) hit = e;
    });
    return hit;
  }
  function offersDrawer(list) {
    return '<p class="bmcF-doffer__h">' + (list.length > 1 ? 'Offers for your cart' : 'An offer for your cart') + '</p>' + list.map(function (o) {
      return '<div class="bmcF-doffer__row">' + (o.i ? '<img src="' + esc(o.i) + '" alt="" width="44" height="44" loading="lazy">' : '<span class="bmcF-doffer__ph"></span>') +
        '<p class="bmcF-doffer__t"><strong>' + esc(o.t) + '</strong> ' + esc(o.s) + '</p>' +
        '<button type="button" class="bmcF-doffer__btn" data-bmcf-add="' + esc(o.v) + '" aria-label="' + esc(o.a) + '">Add now</button></div>';
    }).join('');
  }
  var DRAWER_IDS = ['bmcF-doffer', 'bmcF-dsum', 'bmcF-dship', 'bmcW3A-dpt', 'bmcF-dview', 'bmcF-dhelp', 'bmcF-dempty'];
  function paintDrawer() {
    var w = D.getElementById('monster-cart-wrapper');
    if (!w) return;
    var s = F.state;
    if (!live()) { DRAWER_IDS.forEach(drop); return; }
    var n = w.querySelectorAll('.mu-cart-item').length;
    var soOk = {}; (s.items || []).forEach(function (i) { if (i.so) soOk[String(i.v)] = 1; });
    [].forEach.call(w.querySelectorAll('.mu-cart-item'), function (it) { var ok = !!soOk[it.getAttribute('data-variant-id')]; if (it.hasAttribute('data-bmcw3a-so') !== ok) { if (ok) it.setAttribute('data-bmcw3a-so', ''); else it.removeAttribute('data-bmcw3a-so'); } });
    var hdr = w.querySelector('#mu-header .mu-cart-header');
    var title = n && s.count ? 'Your cart (' + itemsWord(s.count) + ')' : 'Your cart';
    if (hdr && hdr.getAttribute('data-bmcf-title') !== title) hdr.setAttribute('data-bmcf-title', title);
    var box = D.getElementById('mu-checkout-container'), btn = D.getElementById('mu-checkout-button');
    if (n && s.count && box && btn) {
      drop('bmcF-dempty');
      // one saving line: Monster draws its own "Savings" row whenever the cart has a discount, so ours stays out then
      var muSave = [].some.call(box.children, function (c) { return !c.hasAttribute('data-bmcf') && /^savings/i.test((c.textContent || '').trim()) && !/(^| )mu-hidden( |$)/.test(c.className) && getComputedStyle(c).display !== 'none'; });
      var offs = live() && s.offers && s.offers.length ? s.offers.slice(0, 2) : null;
      if (offs && zoneOk()) mine('bmcF-doffer', offersDrawer(offs), function (x) { if (box.firstChild !== x) box.insertBefore(x, box.firstChild); });
      else { drop('bmcF-doffer'); if (offs && F.country === null) geo(function () { paintDrawer(); }); }
      var sum = '<div class="bmcF-row"><span>Subtotal (' + itemsWord(s.count) + ')</span><span>' + esc(s.sub) + '</span></div>' +
        (s.save && !muSave ? '<div class="bmcF-row bmcF-row--save"><span>You save</span><span>' + esc(s.save) + '</span></div>' + savesHtml(s, 'bmcW6A-dsave') : '') +
        '<p class="bmcF-tax">Tax, if any, is added at checkout.</p>';
      var a = mine('bmcF-dsum', sum, function (x) { var o = D.getElementById('bmcF-doffer'); var ref = o && o.parentNode === box ? o.nextSibling : box.firstChild; if (ref !== x) box.insertBefore(x, ref); });
      // Monster's own "Savings" row (compare-at prices) stays where Monster puts it; our delivery lines go under it
      var anchor = a;
      [].forEach.call(box.children, function (c) { if (!c.hasAttribute('data-bmcf') && /^savings/i.test((c.textContent || '').trim()) && c.getBoundingClientRect().height) anchor = c; });
      var ship = shipLines(s);
      if (ship) mine('bmcF-dship', ship, function (x) { after(anchor, x); }); else drop('bmcF-dship');
      if (F.pt) {
        ptLoad();
        mine('bmcW3A-dpt', F.pt, function (x) { var ap = D.getElementById('mu-after-pay'); var ref = ap && ap.parentNode === box && getComputedStyle(ap).display !== 'none' ? ap : (D.getElementById('bmcF-dship') || a); after(ref, x); });
      } else drop('bmcW3A-dpt');
      mine('bmcF-dview', '<a href="/cart" class="bmcF-dview__a">View your cart now</a>', function (x) { after(btn, x); });
      var help = (s.starter ? '<p class="is-ok">' + CHECK + '<span>30-day money-back guarantee on starter courses.</span></p>' : '') +
        polDrawer(s) + '<p>Questions? <a href="mailto:' + MAIL + '">' + MAIL + '</a></p>';
      mine('bmcF-dhelp', help, function (x) { if (box.lastChild !== x) box.appendChild(x); });
      var label = 'Check out now, ' + (s.total || '');
      if (btn.getAttribute('aria-label') !== label) btn.setAttribute('aria-label', label);
      fillEta();
    } else {
      ['bmcF-doffer', 'bmcF-dsum', 'bmcF-dship', 'bmcW3A-dpt', 'bmcF-dview', 'bmcF-dhelp'].forEach(drop);
      if (!n) {
        var cont = smallestText(w, /^continue shopping$/i);
        if (cont) {
          mine('bmcF-dempty', '<a class="bmcF-dempty__btn" href="' + BEST + '">Shop our best sellers now</a>' +
            '<a class="bmcF-dempty__link" href="' + BEST_BOOKS + '">Shop best-selling books now</a>', function (x) { after(cont, x); });
        }
      }
    }
  }
  function sig(w) {
    var parts = [];
    [].forEach.call(w.querySelectorAll('.mu-cart-item'), function (it) {
      var q = it.querySelector('.mu-item-quantity');
      parts.push(it.getAttribute('data-variant-id') + 'x' + (q ? q.textContent.trim() : ''));
    });
    var b = D.getElementById('mu-checkout-button');
    return parts.join(',') + '|' + (b ? b.textContent.replace(/\s+/g, ' ').trim() : '');
  }
  var lastSig = null, tq = null;
  function tick() {
    tq = null;
    var w = D.getElementById('monster-cart-wrapper');
    if (!w) return;
    var sg = sig(w);
    if (lastSig === null) {
      var n = w.querySelectorAll('.mu-cart-item').length;
      if (F.state && !n && F.state.lines) return;   // Monster has not drawn the items yet
      lastSig = sg;
      if (!F.state || n !== F.state.lines) { refresh(); return; }
    } else if (sg !== lastSig) {
      lastSig = sg; refresh(); return;
    }
    paintDrawer();
  }
  function soon() { if (!tq) tq = setTimeout(tick, 120); }
  new MutationObserver(function (list) {
    var drawer = false, page = false;
    for (var i = 0; i < list.length && !(drawer && page); i++) {
      var t = list[i].target, e = t.nodeType === 1 ? t : t.parentElement;
      if (!e || !e.closest) continue;
      if (e.closest('[data-bmcf]') || e.closest('#mu-scarcity')) continue;
      if (e.closest('#monster-upsell-cart') || (e === D.body && D.getElementById('monster-cart-wrapper'))) drawer = true;
      else if (e.closest('#main-cart-items, #main-cart-footer')) page = true;
    }
    if (drawer) soon();
    if (page) cartPage();
  }).observe(D.documentElement, { childList: true, subtree: true, characterData: true });

  /* ---------- 2) desktop hover preview ---------- */
  var mq = W.matchMedia ? W.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)') : null;
  var pop = null, showT = null, hideT = null, openNow = false;
  function miniHtml(s) {
    if (!s.count) {
      return '<p class="bmcF-mini__h">Your cart is empty</p>' +
        '<a class="bmcF-mini__btn" href="' + BEST + '">Shop our best sellers now</a>' +
        '<a class="bmcF-mini__link" href="' + BEST_BOOKS + '">Shop best-selling books now</a>';
    }
    var items = (s.items || []).slice(0, 4).map(function (i) {
      return '<li>' + (i.i ? '<img src="' + esc(i.i) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="bmcF-mini__ph"></span>') +
        '<span class="bmcF-mini__t"><a href="' + esc(i.u) + '">' + esc(i.t) + '</a><small>Qty ' + esc(i.q) + '</small></span>' +
        '<b>' + esc(i.p) + '</b></li>';
    }).join('');
    var more = (s.items || []).length > 4 ? '<p class="bmcF-mini__more">+ ' + ((s.items || []).length - 4) + ' more in your cart</p>' : '';
    return '<p class="bmcF-mini__h">Your cart (' + itemsWord(s.count) + ')</p><ul class="bmcF-mini__list">' + items + '</ul>' + more +
      '<div class="bmcF-mini__row"><span>Subtotal</span><b>' + esc(s.sub) + '</b></div>' +
      (s.save ? '<div class="bmcF-mini__row bmcF-mini__save"><span>You save</span><b>' + esc(s.save) + '</b></div>' + savesHtml(s, 'bmcW6A-msave') : '') +
      '<div class="bmcF-mini__ship">' + shipLines(s) + '</div>' +
      (s.ap ? '<p class="bmcW3A-mini__ap">Or 4 interest-free payments of ' + esc(s.ap) + ' every 2 weeks with Afterpay.</p>' : '') +
      (F.pt ? '<div class="bmcW3A-mini__pt">' + F.pt + '</div>' : '') +
      (polLines(s).length ? '<div class="bmcW3A-mini__pol">' + polLines(s).map(function (x) { return '<p>' + x + '</p>'; }).join('') + '</div>' : '') +
      '<a class="bmcF-mini__btn" href="/checkout">' + LOCK + '<span>Check out now</span></a>' +
      '<a class="bmcF-mini__link" href="/cart">View your cart now</a>';
  }
  function place() {
    var icon = D.getElementById('cart-icon-bubble');
    if (!icon || !pop) return;
    var r = icon.getBoundingClientRect();
    pop.style.top = Math.round(r.bottom + 8) + 'px';
    pop.style.right = Math.max(8, Math.round(D.documentElement.clientWidth - r.right)) + 'px';
  }
  function paintMini() {
    if (!pop || !openNow) return;
    if (!live()) { closeMini(); return; }
    var h = miniHtml(F.state);
    if (pop.getAttribute('data-h') !== h) { pop.innerHTML = h; pop.setAttribute('data-h', h); }
  }
  function openMini() {
    if (!mq || !mq.matches || F.tpl === 'cart' || !F.state || !live()) return;
    if (!pop) {
      pop = D.createElement('div'); pop.id = 'bmcF-mini'; pop.setAttribute('data-bmcf', '');
      pop.setAttribute('role', 'region'); pop.setAttribute('aria-label', 'Cart preview');
      pop.addEventListener('mouseenter', function () { clearTimeout(hideT); });
      pop.addEventListener('mouseleave', function () { hideT = setTimeout(closeMini, 250); });
      D.body.appendChild(pop);
    }
    if (F.pt) ptLoad();
    openNow = true; paintMini(); place(); pop.classList.add('is-open');
    if (Date.now() - F.at > 15000) { F.at = Date.now(); refresh(); }
  }
  function closeMini() { openNow = false; if (pop) pop.classList.remove('is-open'); }
  D.addEventListener('mouseover', function (e) {
    var t = e.target && e.target.closest && e.target.closest('#cart-icon-bubble');
    if (!t) return;
    clearTimeout(hideT); if (!openNow) { clearTimeout(showT); showT = setTimeout(openMini, 150); }
  });
  D.addEventListener('mouseout', function (e) {
    var t = e.target && e.target.closest && e.target.closest('#cart-icon-bubble');
    if (!t || (e.relatedTarget && t.contains(e.relatedTarget))) return;
    clearTimeout(showT); hideT = setTimeout(closeMini, 250);
  });
  D.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('#cart-icon-bubble')) { clearTimeout(showT); closeMini(); } }, true);
  W.addEventListener('scroll', function () { if (openNow) closeMini(); }, { passive: true });
  D.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMini(); });

  /* ---------- 3) /cart page ---------- */
  var SAVE_KEY = 'bmcF-saved';
  function saved() { try { return (JSON.parse(localStorage.getItem(SAVE_KEY)) || []).filter(function (x) { return x && x.v && FROZEN.indexOf(x.h) === -1; }); } catch (e) { return []; } }
  function setSaved(a) { try { localStorage.setItem(SAVE_KEY, JSON.stringify(a.slice(0, 20))); } catch (e) {} }
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  function paintSaved() {
    var box = D.getElementById('bmcF-saved');
    if (!box) return;
    var a = saved();
    if (!a.length) { box.hidden = true; box.innerHTML = ''; return; }
    var h = '<h2 class="bmcF-saved__h">Saved for later</h2><ul class="bmcF-saved__list">' + a.map(function (x) {
      return '<li>' + (x.i ? '<img src="' + esc(x.i) + '" alt="" width="60" height="60" loading="lazy">' : '') +
        '<a class="bmcF-saved__t" href="' + esc(x.u) + '">' + esc(x.t) + '</a>' +
        '<span class="bmcF-saved__act"><button type="button" class="button button--secondary bmcF-saved__move" data-v="' + esc(x.v) + '">Move to cart</button>' +
        '<button type="button" class="link bmcF-saved__rm" data-v="' + esc(x.v) + '">Remove</button></span></li>';
    }).join('') + '</ul>';
    if (box.getAttribute('data-h') !== h) { box.innerHTML = h; box.setAttribute('data-h', h); }
    box.hidden = false;
  }
  var cq = null;
  function cartPage() { if (!cq) cq = setTimeout(function () { cq = null; fillEta(); offersPage(); }, 60); }
  function msg(el, t) { if (el) el.textContent = t; }
  D.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var sb = t.closest('.bmcF-savebtn');
    if (sb) {
      e.preventDefault();
      if (sb.disabled) return; sb.disabled = true;
      var a = saved().filter(function (x) { return String(x.v) !== String(sb.dataset.variant); });
      a.unshift({ v: sb.dataset.variant, t: sb.dataset.title, u: sb.dataset.url, i: sb.dataset.img, h: sb.dataset.handle });
      setSaved(a);
      post('/cart/change.js', { line: Number(sb.dataset.line), quantity: 0 }).then(function () { W.location.reload(); })
        .catch(function () { sb.disabled = false; alert('Could not save that item. Please try again.'); });
      return;
    }
    var mv = t.closest('.bmcF-saved__move'), rm = t.closest('.bmcF-saved__rm');
    if (mv || rm) {
      e.preventDefault();
      var v = (mv || rm).dataset.v;
      var rest = saved().filter(function (x) { return String(x.v) !== String(v); });
      if (rm) { setSaved(rest); paintSaved(); return; }
      mv.disabled = true;
      post('/cart/add.js', { items: [{ id: Number(v), quantity: 1 }] }).then(function () { setSaved(rest); W.location.reload(); })
        .catch(function () { mv.disabled = false; alert('That item could not be added. It may no longer be available.'); });
      return;
    }
    var ap = t.closest('.bmcF-code__apply');
    if (ap) { e.preventDefault(); applyCode(ap.closest('.bmcF-code')); return; }
    var rc = t.closest('.bmcF-code__remove');
    if (rc) { e.preventDefault(); removeCode(rc.closest('.bmcF-code'), rc.dataset.code); }
  });
  D.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.id === 'bmcF-code-input') { e.preventDefault(); applyCode(e.target.closest('.bmcF-code')); }
  });
  function codesNow() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { return (c.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; }); }); }
  function applyCode(box) {
    if (!box || box.getAttribute('data-busy')) return;
    var inp = box.querySelector('input'), out = box.querySelector('.bmcF-code__msg');
    var code = (inp.value || '').trim();
    if (!code) { msg(out, 'Type your code first.'); inp.focus(); return; }
    box.setAttribute('data-busy', '1'); msg(out, 'Checking your code...');
    var keep = [];
    codesNow().then(function (have) {
      keep = have.filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
      return post('/cart/update.js', { discount: keep.concat([code]).join(',') });
    }).then(function (c) {
      var hit = (c.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
      if (hit && hit.applicable) { msg(out, 'Code applied. Updating your total...'); W.location.reload(); return; }
      msg(out, 'That code does not work on this cart.');
      return post('/cart/update.js', { discount: keep.join(',') });
    }).catch(function () { msg(out, 'Could not check that code. Please try again.'); })
      .then(function () { box.removeAttribute('data-busy'); });
  }
  function removeCode(box, code) {
    if (!box) return;
    var out = box.querySelector('.bmcF-code__msg');
    codesNow().then(function (have) {
      return post('/cart/update.js', { discount: have.filter(function (c) { return c.toLowerCase() !== String(code).toLowerCase(); }).join(',') });
    }).then(function () { W.location.reload(); }).catch(function () { msg(out, 'Could not remove that code. Please try again.'); });
  }

  /* ---------- 4) cart offers Dan approved 2026-09-28 (snippets/bmcf-offers.liquid): the free book with Music Theory
     1, 2 or 3 and the next book at 20% off. Books ship only to the US, UK and Canada, so every offer row stays hidden
     unless the visitor's country is one of those: Shopify's own geolocation answer, cached per browser session in
     sessionStorage bmc_geo_country (the key the landing pages already use). Unknown country: hidden.
     The Add buttons put the book in the cart; the automatic discount then prices it in the cart and at checkout. */
  var ZONE = ['US', 'GB', 'CA'], GEO_KEY = 'bmc_geo_country', geoWait = null;
  F.country = null;
  function geo(cb) {
    if (F.country !== null) { cb(F.country); return; }
    try { var c = sessionStorage.getItem(GEO_KEY); if (c) { F.country = String(c).toUpperCase(); cb(F.country); return; } } catch (e) {}
    if (geoWait) { geoWait.push(cb); return; }
    geoWait = [cb];
    fetch('/browsing_context_suggestions.json?source=geolocation_recommendation', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { var code = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle; return code ? String(code).toUpperCase() : ''; })
      .catch(function () { return ''; })
      .then(function (code) {
        F.country = code;
        try { if (code) sessionStorage.setItem(GEO_KEY, code); } catch (e) {}
        var l = geoWait; geoWait = null;
        l.forEach(function (f) { try { f(code); } catch (e) {} });
      });
  }
  function zoneOk() { return !!F.country && ZONE.indexOf(F.country) !== -1; }
  F.zoneOk = zoneOk;
  function offersPage() {
    if (!D.querySelector('[data-bmcf-geo]')) return;
    geo(function () {
      var ok = zoneOk() && live();
      [].forEach.call(D.querySelectorAll('[data-bmcf-geo]'), function (el) { if (el.hidden === ok) el.hidden = !ok; });
    });
  }
  D.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-bmcf-add]') : null;
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.disabled || !live()) return;
    var id = Number(b.getAttribute('data-bmcf-add'));
    if (!id) return;
    var label = b.textContent;
    b.disabled = true; b.textContent = 'Adding...';
    var inDrawer = !!b.closest('#monster-cart-wrapper');
    var items = [{ id: id, quantity: 1 }];
    var go;
    if (inDrawer && typeof W.monster_addToCart === 'function') {
      go = new Promise(function (res, rej) { try { res(W.monster_addToCart({ items: items })); } catch (err) { rej(err); } });
    } else {
      go = post('/cart/add.js', { items: items }).then(function () {
        if (!inDrawer) { W.location.reload(); return; }
        if (typeof W.monster_refresh === 'function') { try { W.monster_refresh(); } catch (err) {} }
      });
    }
    go.then(function () { if (inDrawer) refresh(function () { if (b.isConnected && b.disabled) { b.disabled = false; b.textContent = label; } }); })
      .catch(function () { b.disabled = false; b.textContent = label; alert('Could not add that book. Please try again.'); });
  }, true);


  /* ---------- W4A (wave 4, K15): the refund policy in a pop-up over the drawer, never a trip away from the cart ---------- */
  var polDlg = null, polBody = null;
  function polOpen(url) {
    if (!polDlg) {
      polDlg = D.createElement('dialog'); polDlg.id = 'bmcW4A-poldlg'; polDlg.className = 'bmcW4A-poldlg'; polDlg.setAttribute('aria-labelledby', 'bmcW4A-poldlg-h');
      polDlg.innerHTML = '<div class="bmcW4A-poldlg__top"><h2 id="bmcW4A-poldlg-h">Refund policy</h2><button type="button" class="bmcW4A-poldlg__x" data-bmcw4a-polclose aria-label="Close the refund policy">&#10005;</button></div>' +
        '<div class="bmcW4A-poldlg__body" tabindex="0"><p>Loading the policy...</p></div>' +
        '<p class="bmcW4A-poldlg__foot"><a href="' + esc(url) + '">Open the full policy page now</a></p>';
      D.body.appendChild(polDlg);
      polBody = polDlg.querySelector('.bmcW4A-poldlg__body');
      polDlg.addEventListener('click', function (e) { if (e.target === polDlg || (e.target.closest && e.target.closest('[data-bmcw4a-polclose]'))) polDlg.close(); });
    }
    if (typeof polDlg.showModal === 'function') { if (!polDlg.open) polDlg.showModal(); } else polDlg.setAttribute('open', '');
    if (polDlg.getAttribute('data-loaded')) return;
    fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var b = doc.querySelector('.shopify-policy__body') || doc.querySelector('.shopify-policy__container');
      if (!b) throw new Error('no policy body');
      [].forEach.call(b.querySelectorAll('script, style, iframe, link'), function (x) { x.parentNode.removeChild(x); });
      polBody.innerHTML = b.innerHTML; polDlg.setAttribute('data-loaded', '1'); polBody.scrollTop = 0;
    }).catch(function () {
      polBody.innerHTML = '<p>The policy did not load here. <a href="' + esc(url) + '">Open the full policy page now</a></p>';
    });
  }
  D.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-bmcw4a-pol]') : null;
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    polOpen(b.getAttribute('data-bmcw4a-pol'));
  }, true);
  function boot() { fillEta(); paintSaved(); offersPage(); soon(); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
  setTimeout(soon, 1500);
})();
